import ActivityEvent from './models/activityEvent';
import App from './App.vue';
import { AuthPlugin } from './plugins/auth';
import { AuthService } from './auth/authService';
import { AxiosPlugin } from './plugins/axios';
import { AxiosStatic } from 'axios';
import { EnumObject, PipelinePhaseType } from './models/enums';
import Job from './models/job';
import router from './router';
import store from './store';
import { Utilities } from './plugins/utilities';
import Vue from 'vue';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

Vue.use(AxiosPlugin);
Vue.use(AuthPlugin);
Vue.use(Utilities);

declare module 'vue/types/vue' {
  interface Vue {
    $http: AxiosStatic;
    $signalr: AxiosStatic;
    $auth: AuthService;
    isJSON(str: string): boolean;
    sortArray<T, K extends keyof T>(array: Array<T>, sortParam: K, desc?: boolean): Array<T>;
    getEventsStatus(events: Array<ActivityEvent>): number;
    tryFormatJson(input: string): string;
    deepClone<T>(inObject: T | T[]): T | T[];
    enumToArray<T>(enumToProcess: T): EnumObject[];
    arraysAreEqual<T>(array1: T[], array2: T[]): boolean;
    objectsAreEqual<T>(object1: T, object2: T): boolean;
    getIconColor(job: Job, phaseTypeId: PipelinePhaseType | null): string;
    dateRangeTextUtility(dateRange: string[]): string;
  }
}

export const bus = new Vue();

export default new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
